class RangeSliderBase extends Component {
	constructor(el) {
		super(el);
		this.range1 = this.$find('[data-range-1]');
		this.range2 = this.$find('[data-range-2]');
		this.indicator = this.$find('[data-range-indicator]');
		this.eventValues = new CustomEvent('changeValues', {
			detail: {
				getMin: () => this.getMinValue(),
				getMax: () => this.getMaxValue()
			}
		});
		this.addEventListeners();
		this.indicatorResize();
	}

	getMinValue() {
		return Math.min(this.range1.value, this.range2.value);
	}

	getMaxValue() {
		return Math.max(this.range1.value, this.range2.value);
	}

	onElementInput() {
		this.$el.dispatchEvent(this.eventValues);
		this.indicatorResize();
	}

	onElementChange(type) {
		const event = new Event('dragFinish');
		event.sliderType = type;
		this.$el.dispatchEvent(event);
	}

	indicatorResize() {
		const diff = this.range1.max - this.range1.min;
		this.indicator.style.width = Math.abs((this.range1.value - this.range2.value) / diff * 100) + '%';
		this.indicator.style.left = Math.abs((this.getMinValue() - this.range1.min) / diff * 100) + '%';
	}

	addEventListeners() {
		this.range1.addEventListener('input', () => this.onElementInput());
		this.range2.addEventListener('input', () => this.onElementInput());
		this.range1.addEventListener('change', () => this.onElementChange('min'));
		this.range2.addEventListener('change', () => this.onElementChange('max'));
	}
}
